import { capitalizeFirstLetter } from './capitalizeFirstLetter';

export const formatFirebaseProvider = (provider: String) => {
  if (provider === 'password') return 'Email';
  return capitalizeFirstLetter(provider.split('.com')[0]);
};
